<wiz-vgroup width="100%" height="100%">
  <!-- gestion organisation -->
  <wiz-hgroup width="100%" padding="4px" gap="10">
    <!-- minWidth="100px" pour permettre la reduction widget sans qu'il disparaisse entièrement-->
    <widget-renderer
      width="100%"
      minWidth="100px"
      class="view-widget"
      [title]="'$.dashboard.view.manage.data.title.$'"
      [description]="'$.dashboard.view.org.description.$'"
    ></widget-renderer>
    <wiz-vgroup width="285px" [verticalAlign]="'center'" class="widget-purple" padding="10px">
      <wiz-label [wizLabel]="'$.dashboard.view.org.detail.$'"></wiz-label>
      <wiz-button #btnAppModel class="btn-white-hyperlink" [wizLabel]="'$.dashboard.view.org.detail.action.$'">
      </wiz-button>
    </wiz-vgroup>
  </wiz-hgroup>

  <!-- Les chronocodes -->
  <wiz-hgroup width="100%" padding="4px" gap="10">
    <widget-renderer
      width="100%"
      minWidth="100px"
      class="view-widget"
      [titleIcon]="'icon-chronocodes'"
      [title]="'$.chronocode.home.title.$'"
      [description]="'$.chronocode.home.description.$'"
    ></widget-renderer>
    <wiz-vgroup width="285px" [verticalAlign]="'center'" class="widget-white" padding="10px">
      <wiz-button #btnMoreChrono class="hyperButton" [wizLabel]="'$.dashboard.view.choose.chronocode.$'"></wiz-button>
      <wiz-button #btnMoreChrono class="hyperButton" [wizLabel]="'$.dashboard.view.more.chronocode.$'"></wiz-button>
    </wiz-vgroup>
  </wiz-hgroup>

  <!-- Les codifications -->
  <wiz-hgroup width="100%" padding="4px" gap="10">
    <widget-renderer
      width="100%"
      minWidth="100px"
      class="view-widget"
      [titleIcon]="'icon-codifications'"
      [title]="'$.dashboard.view.freedata.title.$'"
      [description]="'$.freedata.home.description.$'"
    ></widget-renderer>
    <wiz-vgroup width="285px" [verticalAlign]="'center'" class="widget-white" padding="10px">
      <wiz-button #btnMoreCodif class="hyperButton" [wizLabel]="'$.dashboard.view.choose.freedata.$'"></wiz-button>
      <wiz-button #btnMoreCodif class="hyperButton" [wizLabel]="'$.dashboard.view.more.freedata.$'"></wiz-button>
    </wiz-vgroup>
  </wiz-hgroup>

  <!-- Les mesures -->
  <wiz-hgroup width="100%" padding="4px" gap="10">
    <widget-renderer
      width="100%"
      minWidth="100px"
      class="view-widget"
      [titleIcon]="'icon-measures'"
      [title]="'$.dashboard.view.measure.title.$'"
      [description]="'$.dashboard.view.measure.description.$'"
    >
    </widget-renderer>
    <wiz-vgroup width="285px" [verticalAlign]="'center'" class="widget-white" padding="10px">
      <wiz-button #btnMoreMeasure class="hyperButton" [wizLabel]="'$.dashboard.view.choose.mesures.$'"></wiz-button>
      <wiz-button #btnMoreMeasures class="hyperButton" [wizLabel]="'$.dashboard.view.more.mesures.$'"></wiz-button>
    </wiz-vgroup>
  </wiz-hgroup>
</wiz-vgroup>
